import { terminals } from './terminals';
import { FunctionComponent } from 'react';
import { HapagLloydCarrierIcon, MaerskCarrierIcon } from '../icons';

export type Carrier = {
  id: string;
  name: string;
  order: number;
  image?: FunctionComponent<JSX.IntrinsicElements['svg']>;
  required: boolean;
};

export const availableCarriers = [
  {
    id: 'MAERSK',
    name: 'Maersk',
    image: MaerskCarrierIcon,
    order: 0,
    required: true,
  },
  {
    id: 'HAPAGLLOYD',
    name: 'Hapag Lloyd',
    image: HapagLloydCarrierIcon,
    order: 1,
    required: true,
  },
  {
    id: 'CMA',
    name: 'CMA CGM',
    order: 2,
    required: false,
  },
  {
    id: 'COS',
    name: 'COSCO SHIPPING',
    order: 3,
    required: false,
  },
  {
    id: 'EMC',
    name: 'Evergreen',
    order: 4,
    required: false,
  },
  {
    id: 'HMM',
    name: 'Hyundai Merchant Marine',
    order: 5,
    required: false,
  },
  {
    id: 'MSC',
    name: 'Mediterranean Shipping Company',
    order: 6,
    required: false,
  },
  {
    id: 'PIL',
    name: 'Pacific International Lines',
    order: 7,
    required: false,
  },
  {
    id: 'YML',
    name: 'Yang Ming Line',
    order: 8,
    required: false,
  },
  {
    id: 'ZIM',
    name: 'Zim Israel Navigation',
    order: 9,
    required: false,
  },
  // Fallback
  {
    id: 'GEMINI_MAERSK',
    name: 'Maersk (Gem) - deprecated',
    image: MaerskCarrierIcon,
    order: 10,
    required: false,
    deprecated: true,
  },
  {
    id: 'GEMINI_HAPAGLLOYD',
    name: 'Hapag Lloyd (Gem) - deprecated',
    image: HapagLloydCarrierIcon,
    order: 11,
    required: false,
    deprecated: true,
  },
  {
    id: 'OTHERS',
    name: 'Others - deprecated',
    order: 12,
    required: false,
    deprecated: true,
  },
];

export const getCarrierById = (carrierId: string): Carrier => {
  return (
    availableCarriers.find((c) => c.id === carrierId) || {
      id: carrierId,
      name: carrierId,
      order: -1,
      required: false,
    }
  );
};

export const getCarriersForTerminal = (terminalCode: string): Carrier[] => {
  const foundTerminal = terminals.find((t) => t.code === terminalCode);
  if (!foundTerminal) {
    return [];
  }
  const terminalCarriers = foundTerminal.carriers;
  if (!terminalCarriers) {
    return [];
  }
  return terminalCarriers.map((c) => getCarrierById(c)) || [];
};

export const isCarriersAvailableForTerminal = (terminalCode: string): boolean =>
  terminals.filter((terminal) => terminal.code === terminalCode)?.[0].carriersAvailable;

export const calculateMovesPercentage = (totalMoves: number, moves: number) => Math.round((moves / totalMoves) * 100);
